'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { registerNavigate } from '@/lib/native-navigation';

/** Registers the Next.js router.push reference for native navigation. */
export function NativeNavigationRegistrar() {
  const router = useRouter();

  useEffect(() => {
    registerNavigate((path) => router.push(path));
  }, [router]);

  return null;
}
